export default {
  isInternalUser(state) {
    return Boolean(state.userInfo.internal_employee);
  },
};
